import { addFilter } from '@wordpress/hooks';
import { createHigherOrderComponent } from '@wordpress/compose';
import { InspectorControls, BlockListBlock } from '@wordpress/block-editor';
import { ToggleControl, PanelBody } from '@wordpress/components';
import { Fragment, createElement } from '@wordpress/element';

// ✅ 1️⃣ Add the `objectFitCover` attribute to `core/image`
const addObjectFitAttribute = (settings, name) => {
    if (name !== 'core/image') return settings;

    return {
        ...settings,
        attributes: {
            ...settings.attributes,
            objectFitCover: {
                type: 'boolean',
                default: false, 
            },
        },
    };
};

addFilter('blocks.registerBlockType', 'sash-theme/extend-image-object-fit', addObjectFitAttribute);

// ✅ 2️⃣ Add a ToggleControl in the block settings
const withObjectFitControl = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        const { attributes, setAttributes, name } = props;
        if (name !== 'core/image') return <BlockEdit {...props} />;

        return (
            <Fragment>
                <BlockEdit {...props} />
                <InspectorControls>
                    <PanelBody title="Image Fit">
                        <ToggleControl
                            label="Fit to Container"
                            checked={attributes.objectFitCover}
                            onChange={(value) => setAttributes({ objectFitCover: value })}
                        />
                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, 'withObjectFitControl');

addFilter('editor.BlockEdit', 'sash-theme/with-object-fit-control', withObjectFitControl);

// ✅ 3️⃣ Modify the <figure> in the saved markup (Frontend)
const modifyImageBlockSave = (element, blockType, attributes) => {
    if (blockType.name !== 'core/image' || !element) return element;

    return createElement(element.type, {
        ...element.props,
        className: `${element.props.className || ''} ${attributes.objectFitCover ? 'object-fit-cover' : ''}`.trim(),
    }, element.props.children);
};

addFilter('blocks.getSaveElement', 'sash-theme/modify-image-save', modifyImageBlockSave);

// ✅ 4️⃣ Apply the class in the editor preview (Backend Editor)
const withObjectFitClass = createHigherOrderComponent((BlockListBlock) => {
    return (props) => {
        if (props.name !== 'core/image') return <BlockListBlock {...props} />;

        return <BlockListBlock {...props} className={`${props.className || ''} ${props.attributes.objectFitCover ? 'object-fit-cover' : ''}`.trim()} />;
    };
}, 'withObjectFitClass');

addFilter('editor.BlockListBlock', 'sash-theme/add-object-fit-class', withObjectFitClass);
